/*
 * File: ui-label.ts
 * File Created: 2023-12-18 11:45:26
 * Author: Val Liu <valuis0429@gmail.com>
 *
 * -----
 * Last Modified: 2024-09-12 03:50:53
 * Modified By: Val Liu
 * -----
 */

import {
    BaseUITag,
    EUITagRuleType,
    EUITagRuleUnion,
    EUITagTarget,
    IUITagInput,
    IUITagResult,
    UITag,
} from "./core";

// @uiDisabled - disable the form element or body cell.
// allow value: true | false | "inherit" (don't change the current value)

@UITag.set()
export class uiDisabled extends BaseUITag {
    appliedTo: EUITagTarget[] = [EUITagTarget.TableBodyCell, EUITagTarget.FormElement];
    ruleTypes: EUITagRuleUnion[] = [EUITagRuleType.Boolean, EUITagRuleType.String];
    allowNullRule: boolean = true; /// default: true

    /// set props :disabled
    parse(input: IUITagInput): IUITagResult | null {
        const rule = this.parseRule(input) ?? true;
        if (rule == "inherit") return null;

        return {
            props: {
                disabled: Boolean(rule),
            },
        };
    }
}
